import { render } from "./AvanzandoHaciaElFuturoView.vue?vue&type=template&id=23d2e2cb"
import script from "./AvanzandoHaciaElFuturoView.vue?vue&type=script&lang=js"
export * from "./AvanzandoHaciaElFuturoView.vue?vue&type=script&lang=js"

import exportComponent from "/home/xavi/Escriptori/rocabo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__